export default __webpack_public_path__ + "static/media/AlecBio.4cd4e777.jpg";